
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse-by-year",
      function () {
        return require("private-next-pages/browse-by-year/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse-by-year"])
      });
    }
  